import { Outlet, Link, router, useParams, useNavigate } from "react-router-dom";

import { useState, useEffect } from "react";
import { AppValues, API, PayMoob } from "../Values";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../LoginCheck/page";
export default function Payment({ }) {
  const navigate = useNavigate();
  const params = useParams();
  const [order, Setorder] = useState("");
  const [Inputs, setInputs] = useState([]);

  //---------CHECK LOGIN------------------------------
  LoginCheck();
  var userinfo = [];
  var Username = "";
  var UserID = "";
  if (Cookies.get("userinfo")) {
    userinfo = JSON.parse(Cookies.get("userinfo"));
    Username = userinfo[0].Name;
    UserID = userinfo[0].ID;
  }

  var Vesanumber_order = [];
  if (Cookies.get("Vesanumber_order")) {
    Vesanumber_order = JSON.parse(Cookies.get("Vesanumber_order"));
  }

  //-------------------------------------------------
  const [amountOrder, setAmountOrder] = useState(params.mony);
  const [amount, setAmount] = useState(params.mony);
  const [Token, SetToken] = useState("");
  const [PaymentKey, SetPaymentKey] = useState("");
  //-------------------------------------------------------
  const [billing_data, setbilling_data] = useState({
    first_name: userinfo[0].Name,
    last_name: "NA",
    email: userinfo[0].Email,
    phone_number: userinfo[0].Mobail,
    country: "EG",
    city: userinfo[0].City,
    state: userinfo[0].State,
    postal_code: "NA",
    street: userinfo[0].Address,
    building: "NA",
    floor: "NA",
    shipping_method: "NA",
    apartment: "NA",
  });

  // useEffect(() => {
  //   handlePayment();
  // }, []);

  async function handlePaymentCash() {

    console.log(Vesanumber_order);
    if (window.confirm(" هل تريد  دفع الاوردر كاش ")) {
      try {
        const post = {
          customer: Vesanumber_order.customer,
          customerId: Vesanumber_order.customerId,
          delevary_name: Vesanumber_order.delevary_name,
          delevary_id: Vesanumber_order.delevary_id,
          number_order: Vesanumber_order.number_order,
          Total: Vesanumber_order.Total,
          Action: "ReplaseOrderVisaToCach",
        };
        const result = await fetch(API.Orders, {
          method: "POST",
          body: JSON.stringify(post),
        });
        const body = await result.json();
        console.log(body);
        if (Vesanumber_order.loginType == "customer") {
          return navigate("../Customer/Orders");
        } else {
          navigate("../Deller/Orders");
        }

      } catch (error) {
        return error;
      }
    }

  }

  async function handlePayment(amount_) {
  // console.log("amount_")
  // console.log(amount_)
    try {
      //==== Step 1: Authentication ========
      const authResponse = await axios.post(
        `https://accept.paymob.com/api/auth/tokens`,
        {
          api_key: PayMoob.api_key,
        }
      );
      const token = authResponse.data.token;
      console.log(authResponse);

      //-------------------------------------------------------
      //==== Step 2: Create Order  ======
      const orderResponse = await axios.post(
        `https://accept.paymob.com/api/ecommerce/orders`,
        {
          auth_token: token,
          delivery_needed: false,
          amount_cents: amount_ * 100, // Convert to cents
          currency: "EGP",
          items: [],
        }
      );
      console.log(orderResponse);
      const orderId = orderResponse.data.id;

      //-------------------------------------------------------
      //==== Step 3: Generate Payment Key  ======
      const paymentKeyResponse = await axios.post(
        `https://accept.paymob.com/api/acceptance/payment_keys`,
        {
          auth_token: token,
          amount_cents: amount_ * 100,
          expiration: 3600,
          order_id: orderId,
          billing_data: billing_data,
          currency: "EGP",
          integration_id: PayMoob.integration_id,
        }
      );
      SetPaymentKey(paymentKeyResponse.data.token);
      console.log(paymentKeyResponse);

    } catch (error) {
      console.error("Payment failed:", error);
      alert("Payment failed!");
      return error;
    }
  }
  //================================================================
  //================================================================
  const checkPaymentStatus = async (transactionId) => {
    const API_URL = `https://accept.paymob.com/api/acceptance/transactions/${transactionId}`;
    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${PayMoob.api_key}`,
        },
      });

      if (response.data) {
        const { is_success, data } = response.data;
        console.log("Payment Data:", data);
        return is_success ? "Payment Successful" : "Payment Failed";
      }
    } catch (error) {
      console.error("Error checking payment status:", error);
      return "Error checking payment status";
    }
  };

  //---------------------------------------------
  //---------------------------------------------
  //---------------------------------------------
  //---------------------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());
    setAmount(data_.amount);
    Cookies.set("VesaAmount", data_.amount, {
      expires: 1,
    });
    handlePayment(data_.amount);
  };

  //================================================================
  //================================================================
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
     setInputs((values) => ({ ...values, [name]: value }));
    // setAmount((values) => ({ ...values, [name]: value }));
    setAmount(value);
    Cookies.set("VesaAmount", value, {
      expires: 1,
    });
  };

  function handleAmount(e) {
    setAmount(e);
    console.log(e);
    Cookies.set("VesaAmount", e, {
      expires: 1,
    });
  }

  return (
    <>
      <LoginCheck />
      <div
        dir="rtl"
        className="row mt-0 text-center0 m-auto"
        style={{ maxWidth: "1800px" }}
      >
        <div className="col-1 py-1 bg-white ">
          <i
            className="fa-solid fa-chevron-right  mt-2 fs-4"
            onClick={() => navigate(-1)}
          ></i>
        </div>
        <div className="col-11 py-1 text-center bg-white">
          <h4 className="fw-normal">Payment Information </h4>
        </div>
        <br />
        {PaymentKey == "" && (
          <div className="col-lg-4 col-12 text-center mt-4 m-auto">
            {amountOrder != null ? <PYMENT_ORDER /> : <PAYMENT_DEUON />}
          </div>
        )}
      </div>
      <div
        dir="rtl"
        className="row mt-0 text-center0 m-auto"
        style={{ maxWidth: "1800px" }}
      >
        {PaymentKey != "" && (
          <div className="col-12 payment 0bg-white text-center">
            <iframe
              src={`https://accept.paymob.com/api/acceptance/iframes/${PayMoob.iframe_id}?payment_token=${PaymentKey}`}
              title="PayMob Payment"
              className="iframe bg-white"
              allow="payment" // Ensures necessary permissions for payment interactions
            ></iframe>
          </div>
        )}
      </div>
    </>
  );
  function PYMENT_ORDER() {
    return (
      <>

        <br />
        <img
          style={{ width: "150px" }}
          src="../Mhfaza.jpg"
          alt=""
        />
        <br />
        <h4>دفع حساب اوردر</h4>
        <h6>{ }</h6>
        <h2 className="text-danger">{`${amount} جنية مصرى`}</h2>




        {Vesanumber_order.loginType != "customer" ? <>

          <button
            className="btn btn-success mt-4 p-1 px-4 fw-bold fs-5 w0-75 m-auto mx-2"
            onClick={() => handlePaymentCash()}
          >
            <img
              style={{ width: "50px" }}
              className="mx-2"
              src="../sdad.png"
              alt=""
            />
            <br />
            {"ادفع كاش "}
          </button>
          <button
            className="btn btn-info  mt-4 p-1 px-4 fw-bold fs-5 w0-75 m-auto mx-2 text-white"
            onClick={() => handlePayment(params.mony)}
          >
            <img
              style={{ width: "50px" }}
              className="mx-2"
              src="../visa2.png"
              alt=""
            />
            <br />
            {"ادفع بالفيزا"}
          </button>
        </>
          :
          <button
            className="btn btn-success  mt-4 p-2 px-4 fw-bold fs-5 0w-75 m-auto mx-2 text-white"
            onClick={() => handlePayment(params.mony)}
          >
            {`ادفع الان ${amount} جنية مصرى`}
          </button>
        }


      </>
    );
  }
  //-------------------------------

  function PAYMENT_DEUON() {
    return (
      <>

        <br />
        <form method="POST" onSubmit={handleSubmit}>

        <img
          style={{ width: "100px" }}
          src="../visa2.png"
          alt=""
        />
        <br />
        <label className="fs-5 fw-bold">
          {"      اكتب المبلغ المراد دفعة"}
        </label>
        <input
          className="form-control mt-4 w-50 m-auto text-center"
          type="number"
          name="amount"
          placeholder="Enter amount"
          // onChange={handleChange}
          // onChange={(e) => handleAmount(e.target.value)}
          // onChange={(e) => setAmount(e.target.value)}
          //  value={Inputs.amount}
          //  value={amount}
        />
        <button
          className="btn btn-success  mt-4 p-1 px-0 fw-bold fs-5 w-75 m-auto "
          // onClick={() => handlePayment()}
        >

          {"ادفع الان"}

        </button>
        </form>
      </>
    );
  }
  //-------------------------------

}
